import { AccountData, TokenResponse } from '@core/swagger-client';
import { createContext, useContext } from 'react';

export interface AuthContext {
    token: string | undefined | null;

    isAuthenticated: boolean;
    isVerified: boolean;
    isMainAccount: boolean;
    managedAccounts: AccountData[];

    mainAccount: AccountData | null;
    activeAccount: AccountData | null;

    hasRights: boolean;
    rights: string[];
    canBroadcast: boolean;
    canInviteAccounts: boolean;
    canManageTranslations: boolean;
    canManageEmailStyle: boolean;
    canManageEmailTemplates: boolean;
    canManageEmailLists: boolean;
    canManageBlacklist: boolean;
    canManageChatLinkDomains: boolean;
    canViewUsageStatistics: boolean;

    refreshToken: () => Promise<void>;
    updateAuthState: (data: TokenResponse) => void;
}

export const AuthContext = createContext<AuthContext>({
    token: undefined,
    isAuthenticated: false,
    isVerified: false,
    isMainAccount: false,
    managedAccounts: [],
    mainAccount: null,
    activeAccount: null,
    hasRights: false,
    rights: [],
    canBroadcast: false,
    canInviteAccounts: false,
    canManageTranslations: false,
    canManageEmailStyle: false,
    canManageEmailTemplates: false,
    canManageEmailLists: false,
    canManageBlacklist: false,
    canManageChatLinkDomains: false,
    canViewUsageStatistics: false,
    refreshToken: async () => {},
    updateAuthState: () => {}
});

// NOTE: The provider is implemented in the frontend app, otherwise the embed-app would fail to build due to a dependency on @tanstach/react-start
export const useAuthContext = () => useContext(AuthContext)!;
